import { render, staticRenderFns } from "./QuestionnaireAnswer.vue?vue&type=template&id=5da746e8&scoped=true&"
import script from "./QuestionnaireAnswer.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireAnswer.vue?vue&type=style&index=0&id=5da746e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da746e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
